var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("emailCampaignModalController", [
    "$scope",
    "$rootScope",
    "mainService",
    "modalService",
    "cookiesFactory",
    "$timeout",
    "$document",
    "loaderService",
    function (
        $scope,
        $rootScope,
        mainService,
        modalService,
        cookiesFactory,
        $timeout,
        $document,
        loaderService
    ) {
        // Initialize form object
        $scope.signUpModal = {
            form: {}
        };
        
        //#region Modalpoup helper
        $scope.toggleModal = function (key, state) {
            if (state) {
                modalService.open(key);
            } else {
                if (!angular.isUndefined($scope.signUpModal) && !angular.isUndefined($scope.signUpModal.form)) {
                    $scope.signupemail = "";
                    $scope.signUpModal.form.$setPristine();
                    $scope.signUpModal.form.$setUntouched();
                    $scope.invalidEmail = false;
                }
                // Always reset the success flag when closing the modal
                $scope.signupemailSuccess = false;
                modalService.close(key);
            }
        };
        //#endregion

        //#region submit Email
        $scope.submitSignupEmail = function () {
            loaderService.show();
            if (
                $scope.signUpModal.form.$valid
            ) {
                var email = $scope.signUpModal.form.signupemail.$modelValue;

                function handleResponse(response) {
                    loaderService.hide();
                    if (response.data === true) {
                        $scope.signupemail = "";
                        $scope.signUpModal.form.$setPristine();
                        $scope.signUpModal.form.$setUntouched();
                        if (typeof gtag !== "undefined" && gtag !== null) {
                            gtag("event", "email_subscribe", {
                                email: email.toLowerCase(),
                            });
                        }
                        $scope.toggleModal("mdlSignUp", true);
                        $scope.signupemailSuccess = true;
                        
                    } else if (response.data === false) {
                        $scope.invalidEmail = true;
                    } else {
                        if (
                            confirm(
                                "The entered email address (" +
                                    email +
                                    ") seems incorrect. Are you sure you want to sign up using this address?"
                            )
                        ) {
                            mainService
                                .insertMailingListEmail(
                                    email.toLowerCase(),
                                    true
                                )
                                .then(handleResponse);
                        } else {
                            loaderService.hide();
                        }
                    }
                }

                mainService
                    .insertMailingListEmail(email.toLowerCase(), false)
                    .then(handleResponse);
            } else {
                // Mark the email field as invalid if form is invalid
                if ($scope.signUpModal.form.signupemail) {
                    $scope.signUpModal.form.signupemail.$invalid = true;
                }
                loaderService.hide();
            }
        };
        //#endregion

        //esc click
        $document.bind("keydown", function (e) {
            if (e.keyCode == 27) {
                //27 is ESC
                //here code for hide modal
                $scope.toggleModal("mdlSignUp", false);
            }
        });

        $scope.resetInvalidEmail = function () {
            $scope.invalidEmail = false;
        };
    },
]);
